function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import { SketchPicker } from 'react-color';

var ColorPicker = function (_Component) {
  _inherits(ColorPicker, _Component);

  function ColorPicker(props) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    var color = '#fff';

    if (props.color) {
      color = props.color;
    }

    _this.state = {
      displayColorPicker: false,
      background: color
    }; //console.log(props.color)

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleChangeComplete = _this.handleChangeComplete.bind(_this);
    return _this;
  }

  ColorPicker.prototype.handleClick = function handleClick() {
    this.setState({
      displayColorPicker: !this.state.displayColorPicker
    });
  };

  ColorPicker.prototype.handleClose = function handleClose() {
    this.setState({
      displayColorPicker: false
    });
  };

  ColorPicker.prototype.handleChange = function handleChange(color) {
    this.setState({
      background: color.hex
    });
  };

  ColorPicker.prototype.handleChangeComplete = function handleChangeComplete(color) {
    //this.setState({ background: color.hex });
    if (this.props.handleColorChange) {
      this.props.handleColorChange(color.hex);
    }
  };

  ColorPicker.prototype.render = function render() {
    var styles = {
      color: {
        width: '36px',
        height: '14px',
        borderRadius: '2px',
        background: this.state.background
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer'
      },
      popover: {
        position: 'absolute',
        zIndex: '2'
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px'
      }
    }; //console.log(this.state.background)

    return React.createElement('div', null, React.createElement('div', {
      style: styles.swatch,
      onClick: this.handleClick
    }, React.createElement('div', {
      style: styles.color
    })), this.state.displayColorPicker ? React.createElement('div', {
      style: styles.popover
    }, React.createElement('div', {
      style: styles.cover,
      onClick: this.handleClose
    }), React.createElement(SketchPicker, {
      disableAlpha: true,
      color: this.state.background,
      onChange: this.handleChange,
      onChangeComplete: this.handleChangeComplete
    })) : null);
  };

  return ColorPicker;
}(Component);

export default ColorPicker;